import React from 'react';
import './index.css';
import './Bootstrap/css/bootstrap.css';
import Navbar from './Navbar';

export default function Services() {
	return (
		<div className="container-md">
			<Navbar />
			
			<div className="container hero-banner" style={{backgroundImage: "url('/image/services.png')", textAlign: "center"}}></div>
			
			<h2 className="title">Services</h2>
			<hr />
			
			<p className="h4 content" style={{marginLeft: "10px"}}>we provide comprehensive consulting services covering the full software development life 
				cycle — from initial strategy and planning to design, development, deployment, and ongoing support. Our team of experienced professionals 
				partners closely with clients to understand their unique business needs and deliver tailored technology solutions that drive measurable 
				results. Whether you're launching a new product, modernizing legacy systems, or scaling existing platforms, we bring the technical expertise 
				and industry insight to help you succeed. </p>

			<p className="h4 content" style={{marginLeft: "10px"}}>Our services span requirements gathering, system architecture, UI/UX design, 
				agile development, quality assurance, DevOps integration, and post-launch maintenance. We specialize in creating scalable, 
				secure, and high-performance software using modern frameworks and cloud-native technologies. With a strong focus on collaboration, 
				transparency, and quality, we ensure that every project is delivered on time, within budget, and aligned with your strategic goals.</p>
			
			<h2 className="title">Product lines</h2>
			<hr />
			
			<div className="row" style={{marginLeft: "10px", marginTop: "10px"}}>
				<div className="col">
					<div className="card mb-3" style={{maxWidth: "540px"}}>
					  <div className="row g-0">
						<div className="col-md-4" style={{backgroundImage: "url('/image/front_end.png')", backgroundRepeat:"no-repeat"}}>
						</div>
						<div className="col-md-8">
						  <div className="card-body" style={{color: "#2556A6"}}>
							<h5 className="card-title content" style={{fontSize: "21px", fontWeight: "bold"}}>Front End UI Design/Development</h5>
							<p className="card-text content" style={{fontSize: "18px"}}>We craft intuitive, user-centric front-end experiences that are 
								visually engaging and functionally seamless. Our UI/UX design team works closely with clients to understand user behaviors 
								and business objectives, translating them into responsive and accessible interfaces. We develop with modern JavaScript 
								frameworks such as React, Angular, and Vue.js, ensuring high performance across devices while maintaining scalability 
								and brand consistency.</p>
						  </div>
						</div>
					  </div>
					</div>
				</div>
				<div className="col">
					<div className="card mb-3" style={{maxWidth: "540px"}}>
					  <div className="row g-0">
						<div className="col-md-4" style={{backgroundImage: "url('/image/back_end.png')", backgroundRepeat:"no-repeat", marginTop: "14px"}}>
						</div>
						<div className="col-md-8">
						  <div className="card-body" style={{color: "#2556A6"}}>
							<h5 className="card-title content" style={{fontSize: "21px", fontWeight: "bold"}}>Backend Micro-services Development</h5>
							<p className="card-text content" style={{fontSize: "18px"}}>Our back-end services are built on a microservices architecture to 
								ensure flexibility, resilience, and ease of maintenance. We design and develop modular, API-driven services that can evolve 
								with your business. Leveraging languages and frameworks like Java, Node.js, .NET, and Spring Boot, we ensure each service is 
								secure, independently deployable, and optimized for high availability.</p>
						  </div>
						</div>
					  </div>
					</div>
				</div>
			</div>
			<div className="row" style={{marginLeft: "10px", marginTop: "10px", marginBottom: "20px"}}>
				<div className="col">
					<div className="card mb-3" style={{maxWidth: "540px"}}>
					  <div className="row g-0">
						<div className="col-md-4" style={{backgroundImage: "url('/image/database.png')", backgroundRepeat:"no-repeat"}}>
						</div>
						<div className="col-md-8">
						  <div className="card-body" style={{color: "#2556A6"}}>
							<h5 className="card-title content" style={{fontSize: "21px", fontWeight: "bold"}}>Database Development</h5>
							<p className="card-text content" style={{fontSize: "18px"}}>Data is the foundation of any modern application. Our database 
								development services encompass schema design, data modeling, performance tuning, and integration with both SQL (e.g., 
								PostgreSQL, MySQL, SQL Server) and NoSQL (e.g., MongoDB, Redis) solutions. We ensure data consistency, scalability, 
								and security while aligning with your application's specific workload and reporting needs.</p>
						  </div>
						</div>
					  </div>
					</div>
				</div>
				<div className="col">
					<div className="card mb-3" style={{maxWidth: "540px"}}>
					  <div className="row g-0">
						<div className="col-md-4" style={{backgroundImage: "url('/image/cloud.jpg')", backgroundRepeat:"no-repeat"}}>
						</div>
						<div className="col-md-8">
						  <div className="card-body" style={{color: "#2556A6"}}>
							<h5 className="card-title content" style={{fontSize: "21px", fontWeight: "bold"}}>Cloud Development</h5>
							<p className="card-text content" style={{fontSize: "18px"}}>We help organizations harness the power of the cloud to deliver scalable 
								and cost-efficient solutions. Our cloud development services include designing cloud-native applications, setting up 
								CI/CD pipelines, and automating infrastructure using tools like Terraform and Kubernetes. We support major cloud platforms 
								including AWS, Azure, and Google Cloud, enabling seamless deployment, monitoring, and scaling in production environments.</p>
						  </div>
						</div>
					  </div>
					</div>
				</div>
			</div>
			
 			<div className="container footer-bar">
				<p>© Copyright 2026 - DOTDIP Solutions Inc.</p>
			</div>
 		</div>
	);
}